import React from 'react';
import { useContentVisibilityDetection } from '../useContentVisibilityDetection/useContentVisibilityDetection';
/**
 * Custom hook that detect when the content is visible enough to apply scroll on it or over its container
 *
 * @returns An object the `handleContentVisibility` callback function to initialize the hook.
 */
export const useContentVisibility = ({ minVisibleHeight = 100, }) => {
    const containerRef = React.useRef(null);
    const contentRef = React.useRef(null);
    const handleContentVisible = () => {
        const container = containerRef.current;
        const content = contentRef.current;
        if (!container || !content) {
            return;
        }
        container.style.overflowY = '';
        content.style.overflowY = '';
    };
    const handleContentInvisible = () => {
        const container = containerRef.current;
        const content = contentRef.current;
        if (!container || !content) {
            return;
        }
        container.style.overflowY = 'auto';
        content.style.overflowY = 'visible';
    };
    const { handleContentVisibilityDetection } = useContentVisibilityDetection({
        minVisibleHeight,
        onContentVisible: handleContentVisible,
        onContentInvisible: handleContentInvisible,
    });
    const handleContentVisibility = React.useCallback(({ container, content }) => {
        containerRef.current = container;
        contentRef.current = content;
        handleContentVisibilityDetection({ content, container });
    }, [handleContentVisibilityDetection]);
    return { handleContentVisibility };
};
//# sourceMappingURL=useContentVisibility.js.map